import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    total: 0,
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
